import JustValidate from 'just-validate';
import bookingInitDataStorage from './data-storage';
import bookingDataStorage from '../data-storage';

declare let booking_object: any;

export default class sendInitForm{ 

    private form: HTMLFormElement | null;
    private button: HTMLButtonElement | null;

    private modDataStorage = new bookingInitDataStorage();

    private dataStorage = new bookingDataStorage();

    constructor(private formSelector: string, private buttonSelector: string){
        
        this.form = document.querySelector<HTMLFormElement>(formSelector);
        this.button = document.querySelector<HTMLButtonElement>(buttonSelector);
        this.setupValidation();

    }

    /**
     * Sets up form validation rules using JustValidate.
     */
    private setupValidation() {
        
        const validation = new JustValidate(this.formSelector, {
            errorFieldCssClass: 'is-invalid bg-red-050 border border-red-700 focus:border-red-700 focus:ring-red-700 placeholder:text-gray-900',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 fluid-text-sm text-red-700',
            focusInvalidField: true,
            lockForm: true,
        });

        this.addValidationRules(validation);

    }

    /**
     * Adds validation rules for the form fields.
     */
    private addValidationRules(validation: JustValidate) {
        
        const _that = this;

        validation
        .addField('#field-init-room', [
            { rule: 'required', errorMessage: booking_object.error_messages.required },
        ])
        .addField('#field-init-game', [
            { rule: 'required', errorMessage: booking_object.error_messages.required },
        ])
        .addField('#field-init-book-calendar', [
            { rule: 'required', errorMessage: booking_object.error_messages.required },
        ])
        .addField('#field-init-time-slot', [
            { rule: 'required', errorMessage: booking_object.error_messages.required },
        ])
        .addField('#field-init-players', [
            { rule: 'required', errorMessage: booking_object.error_messages.required },
        ])
        .onSuccess((event) => {
            
            event?.preventDefault();

            if(_that.button !== null){

                _that.button.disabled = true;
                const spinner = _that.createSpinner();
                _that.button.appendChild(spinner);

            }

            const form = event.target as HTMLFormElement;
            this.submitForm(form);
                
        });

    }

    /**
     * Submits form.
     * @param form 
     * @returns 
     */
    private submitForm(form: HTMLFormElement){
        
        if (!this.form) return;
        
        const formData = new FormData(form);

        const bookingData = {
            room_id: formData.get("field-init-room") as string,
            game_id: formData.get("field-init-game") as string,
            date: formData.get("field-init-book-calendar") as string,
            slot_time: formData.get("field-init-time-slot") as string,
            players: formData.get("field-init-players") as string
        };

        this.dataStorage.removeStoredValue();
        this.dataStorage.removeStorageStep();
        this.dataStorage.removeStorageByTime

        this.modDataStorage.setLocalStorage(bookingData);

        const url = booking_object.page_order;

        setTimeout(function() {
            window.location.assign(url);
        }, 300);

    }

    /**
     * Creates a loading spinner icon.
     * @returns 
     */
    private createSpinner(): HTMLElement{

        const spinner = document.createElement('i');
        spinner.id = 'bgdrop-spin';
        spinner.className = 'fa-solid fa-circle-notch fa-spin ml-1 mt-1';
        return spinner;

    }

}